import React, { useCallback } from 'react';
import { LABELS_CONFIG } from '@/Hooks/PUJ/constants';
import getLabel from '@/Utils/LabelsConfig';
import { Button } from 'antd';
import useSimpleModal from '@/Components/Modal/useSimpleModal';
import { ButtonStyle } from '@/Components/Modal/SimpleModal';
import useDeviceSessions from '@/Hooks/useDeviceSessions';
import { AppId, SignOutDeviceType } from '@skytvnz/sky-app-store/lib/types/graph-ql';
import pageViewedAnalytics, { PageName, PageViewedAnalyticsProps } from '@/Analytics/Page';
import useAuth from '@/Hooks/useAuth';
import styles from './styles.module.scss';

export enum Position {
  Top = 'top',
  Bottom = 'bottom',
}
export interface Props {
  position: Position;
  segmentPayload?: PageViewedAnalyticsProps;
}

const SignOut: React.FC<Props> = props => {
  const { signOut } = useAuth();
  const { openModal } = useSimpleModal();
  const { signOutFromDevice } = useDeviceSessions();
  const { position, segmentPayload } = props;
  const labelSignOutFromAll = getLabel(LABELS_CONFIG.MANAGE_DEVICE_SIGN_OUT_FROM_ALL) ?? '';
  const labelSignOutModalHeader = getLabel(LABELS_CONFIG.MANAGE_DEVICE_MODAL_HEADER) ?? '';
  const labelSignOutModalDescription =
    getLabel(LABELS_CONFIG.MANAGE_DEVICE_MODAL_DESCRIPTION) ?? '';
  const labelSignOutModalOk = getLabel(LABELS_CONFIG.MANAGE_DEVICE_MODAL_OK) ?? '';
  const labelSignOutModalCancel = getLabel(LABELS_CONFIG.MANAGE_DEVICE_MODAL_CANCEL) ?? '';
  const customStyle = {
    modal: styles.customModal,
    modalTitle: styles.customModalTitle,
    modalContent: styles.customModalContent,
    modalButtonRowContainer: styles.customModalButtonRowContainer,
    okButtonStyle: ButtonStyle.PRIMARY,
    cancelButtonStyle: ButtonStyle.DEFAULT,
  };

  const onClickHandler = useCallback(() => {
    openModal({
      customStyle,
      title: labelSignOutModalHeader as string,
      content: labelSignOutModalDescription,
      okText: labelSignOutModalOk as string,
      cancelable: true,
      cancelText: labelSignOutModalCancel as string,
      onClose: () => {},
      onCancel: () => {},
      onOk: () => {
        pageViewedAnalytics(PageName.SignOutAll, segmentPayload);
        signOutFromDevice(AppId.SkyGoWeb, [SignOutDeviceType.WEB, SignOutDeviceType.MOBILE]);
        signOut();
      },
    });
  }, [
    openModal,
    customStyle,
    labelSignOutModalHeader,
    labelSignOutModalDescription,
    labelSignOutModalOk,
    labelSignOutModalCancel,
    signOutFromDevice,
    segmentPayload,
    signOut,
  ]);

  if (position === Position.Bottom) {
    return (
      <div className={styles.bottomPosition}>
        <Button onClick={onClickHandler} onKeyDown={onClickHandler} type="primary">
          {labelSignOutFromAll}
        </Button>
      </div>
    );
  }

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClickHandler}
      onKeyDown={onClickHandler}
      data-testid="signoutfromall-container"
      className={styles.signOutFromAll}
    >
      {labelSignOutFromAll}
    </div>
  );
};

export default SignOut;
